<script setup>
import { ref, computed, onMounted } from 'vue';
import { Button } from '@components';
const formychat = formychat_admin_vars || {}

import { useUpgrade } from '@store/Upgrade.js';
const $upgrade = useUpgrade();

const currentTime = ref(new Date());

// Read SDK data directly in computed — WPPOOL_Plugins is available by the time
// user clicks a locked feature (modal is never shown on initial page load).
const sdkCampaign = computed(() => {
    return window.WPPOOL_Plugins?.plugins?.social_contact_form || {};
})

const isCampaign = computed(() => {
    const sdk = sdkCampaign.value;
    if (!sdk.background_image || !sdk.from || !sdk.to) return false;
    const now = new Date();
    return now > new Date(sdk.from) && now < new Date(sdk.to);
})

const timer = computed(() => {
    const now = currentTime.value;
    const end_date = new Date(sdkCampaign.value.to);
    const diff = end_date - now;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds }
})

const bg_image = computed(() => {
    if (isCampaign.value) return sdkCampaign.value.background_image;
    return null;
})

const btn_text = computed(() => {
    if (isCampaign.value) return sdkCampaign.value.button_text || 'Grab Your Deals!';
    return 'GET PREMIUM';
})

const btn_link = computed(() => {
    if (isCampaign.value) return sdkCampaign.value.button_link;
    return 'https://lnk.wppool.dev/bTUp5Cu';
})

onMounted(() => {
    document.addEventListener('click', (e) => {
        if (e.target.closest('.formychat-locked')) {
            e.preventDefault();
            $upgrade.show()
        }
    });

    setInterval(() => {
        currentTime.value = new Date();
    }, 1000);
})
</script>
<template>
    <div class="z-50" v-if="!formychat.is_premium">
        <transition name="fast-fade">
            <div v-if="$upgrade.isShown" class="flex items-center h-full w-full justify-center z-50">
                <div @click="$upgrade.hide" class="absolute z-40 left-0 top-0 w-full h-full bg-black opacity-20"></div>
                <div class="flex items-center justify-center">
                    <div
                        class="fixed w-full max-w-lg flex flex-col gap-4 h-auto top-1/2 -translate-y-1/2 z-50 rounded-xl shadow-lg drop-shadow-lg">
                        <img v-if="bg_image" :src="bg_image" class="h-full w-auto mx-auto">
                        <img v-else :src="Image('upgrade.png')" class="h-full w-auto mx-auto">
                        <!-- close  -->
                        <svg @click="$upgrade.hide" xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6 text-gray-500 absolute hover:scale-125 transition right-4 top-4 cursor-pointer"
                            fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        <div class="absolute bottom-4 left-1/2 -translate-x-1/2">
                            <!-- counter  -->
                            <div v-if="isCampaign" class="flex items-center justify-center gap-3 pb-7">
                                <div
                                    class="w-20 h-20 bg-gray-50 bg-opacity-[.05] rounded-lg text-xs uppercase text-gray-300 flex flex-col gap-2 items-center justify-center">
                                    <span class="text-4xl tracking-wider font-medium text-white">{{timer.days}}</span> <span>DAYS</span>
                                </div>
                                <div
                                    class="w-20 h-20 bg-gray-50 bg-opacity-[.05] rounded-lg text-xs uppercase text-gray-300 flex flex-col gap-2 items-center justify-center">
                                    <span class="text-4xl tracking-wider font-medium text-white">{{timer.hours}}</span> <span>HOURS</span>
                                </div>
                                <div
                                    class="w-20 h-20 bg-gray-50 bg-opacity-[.05] rounded-lg text-xs uppercase text-gray-300 flex flex-col gap-2 items-center justify-center">
                                    <span class="text-4xl tracking-wider font-medium text-white">{{timer.minutes}}</span> <span>MINUTES</span>
                                </div>
                                <div
                                    class="w-20 h-20 bg-gray-50 bg-opacity-[.05] rounded-lg text-xs uppercase text-gray-300 flex flex-col gap-2 items-center justify-center">
                                    <span class="text-4xl tracking-wider font-medium text-white">{{timer.seconds}}</span> <span>SECONDS</span>
                                </div>
                            </div>
                            <Button class="font-medium px-6 h-12 text-base text-center flex items-center justify-center" a
                            :href="btn_link"
                                target="_blank">{{ btn_text }}</Button>
                            <div class="text-center mt-4">
                                <a href="https://lnk.wppool.dev/tBWyyUk"
                                    class="text-indigo-200 cursor-pointer hover:text-white transition text-base"
                                    target="_blank">Try a free demo</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
